export default __webpack_public_path__ + "static/media/GS25.951adbb4.png";